import { BotConfigListResponse, BotConfigSummarySchema, BotConfigUpsert, BotSessionListResponse, LlmCredentialListResponse, LlmCredentialSummarySchema, LlmCredentialUpsert, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchBotConfigs = async (signal) => BotConfigListResponse.parse(await request('/api/v1/communication/bot/configs', { signal })).configs;
export const saveBotConfig = async (input) => BotConfigSummarySchema.parse(await request('/api/v1/communication/bot/configs', {
    method: 'PUT',
    body: BotConfigUpsert.parse(input),
}));
export const fetchLlmCredentials = async (signal) => LlmCredentialListResponse.parse(await request('/api/v1/communication/bot/credentials', { signal })).credentials;
export const saveLlmCredential = async (input) => LlmCredentialSummarySchema.parse(await request('/api/v1/communication/bot/credentials', {
    method: 'PUT',
    body: LlmCredentialUpsert.parse(input),
}));
export const fetchBotSessions = async (signal) => BotSessionListResponse.parse(await request('/api/v1/communication/bot/sessions', { signal }));
//# sourceMappingURL=communication-bot.js.map